<template>
  <div
    style="height:45px"
    class="masterhead"
    ref="masterhead"
  > <!-- .masterhead -->
    <div class="masterhead__items info-panel">
      <div class="logo"><h1 style="font-size:25px">Super Admin</h1></div>
      <div class="cpanel" style="position:absolute;right:0px;width:200px;top:10px">
        <div class="cpanel__items -switchtheme" v-if="theme">
          <select-list
            :title="theme"
            v-model="theme"
          >
            <select-option
              value="dark"
              name="dark"
              @click.native="switchTheme(theme, 'dark')"
            >
              dark
            </select-option>
            <select-option
              value="light"
              name="light"
              @click.native="switchTheme(theme, 'light')"
            >
              light
            </select-option>
          </select-list>
        </div>

        <div class="cpanel__items -switchlang" v-if="lang && !isSuperAdmin()">
          <select-list
            :title="lang"
            v-model="lang"
          >
            <select-option
              value="en"
              name="en"
              @click.native="switchLang('en')"
            >
              en
            </select-option>

            <select-option
              value="kr"
              name="kr"
              @click.native="switchLang('kr')"
            >
              kr
            </select-option>

            <select-option
              value="jp"
              name="jp"
              @click.native="switchLang('jp')"
            >
              jp
            </select-option>
          </select-list>
        </div>

        <div class="cpanel__items -logout">
          <button class="btn--logout">
            <router-link to="/logout" />

            {{ translate(common, 'logout') }}
          </button>
        </div>
      </div>

      <div class="notif-logs"  v-if="allTotal && !isSuperAdmin()"  >
        <div
          class="logs-count"
          :class="{'-animate': notif.cashin, '-animate': allTotal.total_cash_in }"
        >
          <router-link  to="/transfers/cashin/pending"></router-link>
          <span class="logs-count--lbl">cash in</span>
          <span class="logs-count--count">{{allTotal.total_cash_in  | FormatAmount('whole')}}</span>
        </div>

        <div class="logs-count"
          :class="{'-animate': notif.cashout, '-animate': allTotal.total_cash_out }"
        >
          <router-link  to="/transfers/cashout/pending"></router-link>
          <span class="logs-count--lbl">cash out</span>
          <span class="logs-count--count">{{allTotal.total_cash_out  | FormatAmount('whole')}}</span>
        </div>

        <div
          class="logs-count"
          :class="{'-animate': notif.cashwait, '-animate': allTotal.total_pending_cash}"
        >
          <router-link  to="/transfers/all/waiting"></router-link>
          <span class="logs-count--lbl">cash wait</span>
          <span class="logs-count--count">{{allTotal.total_pending_cash | FormatAmount('whole')}}</span>
        </div>

        <div
          class="logs-count"
          :class="{'-animate': notif.help, '-animate': allTotal.total_pending_help}"
        >
          <router-link to="/support/requests/all"></router-link>
          <span class="logs-count--lbl">help</span>
          <span class="logs-count--count">{{allTotal.total_pending_help | FormatAmount('whole')}}</span>
        </div>

        <div
          class="logs-count"
          :class="{'-animate': notif.newuser, '-animate': allTotal.total_pending_users}"
        >
          <router-link to="/users/pending"></router-link>
          <span class="logs-count--lbl">new user</span>
          <span class="logs-count--count">{{allTotal.total_pending_users | FormatAmount('whole')}}</span>
        </div>

        <div
          class="logs-count"
          :class="{'-animate': allTotal.total_waiting_users}"
        >
          <router-link to="/users/waiting"></router-link>
          <span class="logs-count--lbl">wait user</span>
          <span class="logs-count--count">{{allTotal.total_waiting_users | FormatAmount('whole')}}</span>
        </div>
      </div>
    </div>

    <div class="masterhead__items statistics" v-if="!isSuperAdmin()">
      <div class="stat-panel">
        <div class="logs-count-title">
          <span>user info</span>
        </div>
        <div class="logs-count">
          <span class="logs-count--lbl">users</span>
          <span class="logs-count--count" v-if="usersInfo">{{usersInfo.total | FormatAmount('whole')}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">online</span>
          <span class="logs-count--count" v-if="usersInfo">{{usersInfo.total_online | FormatAmount('whole')}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">betting</span>
          <span class="logs-count--count">0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">new</span>
          <span class="logs-count--count" v-if="usersInfo">{{usersInfo.total_new | FormatAmount('whole')}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>
      </div>
      <div class="stat-panel">
        <div class="logs-count-title">
          <span>cash info</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">in</span>
          <span class="logs-count--count" v-if="cashInfo">{{cashInfo.total_cash_in | FormatAmount}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">out</span>
          <span class="logs-count--count" v-if="cashInfo">{{cashInfo.total_cash_out | FormatAmount}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">net</span>
          <span class="logs-count--count" v-if="cashInfo">{{cashInfo.net | FormatAmount}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">users</span>
          <span class="logs-count--count" v-if="cashInfo">{{cashInfo.count | FormatAmount('whole')}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>
      </div>

      <div class="stat-panel">
        <div class="logs-count-title">
          <span>betting info</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">bet</span>
          <span class="logs-count--count" v-if="betInfo">{{betInfo.total_bet_amount | FormatAmount('whole')}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">win</span>
          <span class="logs-count--count" v-if="betInfo">{{betInfo.total_win_amount |  FormatAmount('whole')}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">net</span>
          <span class="logs-count--count" v-if="betInfo">{{betInfo.net |  FormatAmount('whole')}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">users</span>
          <span class="logs-count--count" v-if="betInfo">{{betInfo.total_users |  FormatAmount('whole')}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>
      </div>

      <div class="stat-panel">
        <div class="logs-count-title">
          <span>sports info</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">bet</span>
          <span class="logs-count--count">0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">win</span>
          <span class="logs-count--count">0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">net</span>
          <span class="logs-count--count">0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">users</span>
          <span class="logs-count--count">0</span>
        </div>
      </div>

      <div class="stat-panel">
        <div class="logs-count-title">
          <span>minigame info</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">bet</span>
          <span class="logs-count--count">0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">win</span>
          <span class="logs-count--count">0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">net</span>
          <span class="logs-count--count">0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">users</span>
          <span class="logs-count--count">0</span>
        </div>
      </div>

      <div class="stat-panel">
        <div class="logs-count-title">
          <span>point info</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">auto</span>
          <span class="logs-count--count" v-if="pointsInfo">{{pointsInfo.total_auto | FormatAmount('whole')}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">give</span>
          <span class="logs-count--count" v-if="pointsInfo">{{pointsInfo.total_give | FormatAmount('whole')}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">refund</span>
          <span class="logs-count--count" v-if="pointsInfo">{{pointsInfo.total_refund | FormatAmount('whole')}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">net</span>
          <span class="logs-count--count">0</span>
        </div>
      </div>

      <div class="stat-panel">
        <div class="logs-count-title">
          <span>manual info</span>
        </div>
        <div class="logs-count">
          <span class="logs-count--lbl">give</span>
          <span class="logs-count--count" v-if="manualCashInfo">{{manualCashInfo.total_cash_in  | FormatAmount('whole')}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">refund</span>
          <span class="logs-count--count" v-if="manualCashInfo">{{manualCashInfo.total_cash_out  | FormatAmount('whole')}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl">net</span>
          <span class="logs-count--count" v-if="manualCashInfo">{{manualCashInfo.net  | FormatAmount('whole')}}</span>
          <span class="logs-count--count" v-else>0</span>
        </div>

        <div class="logs-count">
          <span class="logs-count--lbl"></span>
          <span class="logs-count--count" v-if="manualCashInfo">{{manualCashInfo.net  | FormatAmount('whole')}}</span>
        </div>
      </div>
    </div>
  </div> <!-- // .masterhead -->
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isSuperAdmin } from '@/assets/js/mixins/base/isSuperAdmin'
//= jquery
import $ from 'jquery'

//= translation
import { common } from '@/assets/js/translations/Common'

//= filters
import FormatAmount from '@/assets/js/filters/FormatAmount'

//= components
import '@/components/base/select/Select'

export default {
  name: 'masterhead',

  data () {
    return {
      common,
      drawer: false,
      theme: localStorage.theme || 'dark',
      lang: localStorage.lang || 'en',
      masterhead_h: null
    }
  },
  mixins: [ isSuperAdmin ],
  filters: {
    FormatAmount
  },

  computed: {
    ...mapState('config', ['config']),
    ...mapState('meta', ['allTotal', 'cashInfo', 'usersInfo', 'notif', 'manualCashInfo', 'betInfo', 'pointsInfo'])
  },

  watch: {
    theme (newValue, oldValue) {
      this.switchTheme(oldValue, newValue, true)
    },

    async $route (to, from) {
      if (_.isEmpty(this.config) && localStorage.token) {
        await this.getConfig()
        this.theme = this.config.theme
        this.lang = this.config.lang
      }
    }
  },

  async mounted () {
    if (_.isEmpty(this.config)) {
      await this.getConfig()
      this.theme = this.config.theme
      this.lang = this.config.lang
    }

    if (this.theme) {
      $('body').removeClass('theme-dark').addClass('theme-' + this.theme)
    }

    this.$nextTick(() => {
      if (this.$refs.masterhead) {
        this.masterhead_h = this.$refs.masterhead.offsetHeight
      }
    })
  },

  async created () {
    if (localStorage.token) {
      await this.getMeta()
      this.theme = this.config.theme
      this.lang = this.config.lang
      await this.getBetInfo()
      await this.getCashInfo()
      await this.getUsersInfo()
      await this.getManualInfo()
      await this.getPointsInfo()
    }
  },

  methods: {
    ...mapActions('config', { getConfig: 'get', updateConfig: 'update' }),
    ...mapActions('meta', { getMeta: 'get' }),
    ...mapActions('meta', ['getCashInfo', 'getUsersInfo', 'getManualInfo', 'getBetInfo', 'getPointsInfo']),

    switchTheme (oldType, newType, flag) { // 3rd param flag  for update
      let newTheme = 'theme-' + newType
      let oldTheme = 'theme-' + oldType
      $('body').removeClass(oldTheme).addClass(newTheme)
      localStorage.setItem('theme', newType)
      if (!flag) {
        this.config.theme = newType
        this.updateConfig(this.config)
      }
    },
    switchLang (lang) {
      this.config.lang = lang
      localStorage.setItem('lang', lang)
      this.updateConfig(this.config)
    }
  }
}
</script>
